export const edData = [
	{
		id: 1,
		name: 'Bachelor in Mathematics and Physics',
		type: 'Tunis-ElManar University',
		about: {
			date: 'September 2013 - July 2016',
			info: 'During my undergraduate studies in Mathematics and Physics, I developed a strong understanding of fundamental concepts in calculus, algebra, quantum mechanics, and classical physics.<br><br>The rigorous coursework provided me with analytical and problem-solving skills, which I applied through hands-on experiments and collaborative projects.<br><br>I also participated in research initiatives focused on mathematical modeling and physical simulations, further enhancing my ability to approach scientific challenges with precision and critical thinking.',
			subTitle: '',
			list: [],
		},
		moreInfo: {
			title: '',
			text: '',
		},
	},
	{
		id: 2,
		name: 'Master Degree in Condensed Matter Physics',
		type: 'Research Center of Borj Cedria, Tunisia',
		about: {
			date: 'September 2016 - July 2018',
			info: 'In my Master’s program in Nanomaterials of Physics, I specialized in the study and application of nanoscale materials. My research explored the properties and potential uses of nanomaterials in advanced technologies such as energy storage, sensors, and electronics.<br><br>Through this program, I gained hands-on experience with state-of-the-art techniques like electron microscopy and spectroscopy. I also honed my skills in conducting scientific research, analyzing data, and presenting findings in academic settings.<br><br>Collaborating with interdisciplinary teams allowed me to explore real-world applications of nanotechnology, solidifying my expertise in this cutting-edge field.',
			subTitle: '',
			list: [],
		},
		moreInfo: {
			title: '',
			text: '',
		},
	},
];
